import type { ReactNode } from "react";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

interface SiteLayoutProps {
  readonly activePath: string;
  readonly children: ReactNode;
}

export function SiteLayout({ activePath, children }: SiteLayoutProps) {
  return (
    <div className="app-frame">
      <SiteHeader activePath={activePath} />
      {children}
      <SiteFooter />
    </div>
  );
}
